<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined && planOptions">
    <v-layout v-if="headers && headers.length > 0">
      <v-row justify="center">
        <v-col style="max-width:1200px">
          <material-card
            v-show="headers"
            :title="$t('components.employers.search_employers_form.title')"
            :color="$vuetify.theme.themes.light.secondary"
            icon="person_search"
          >
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <no-autocomplete-textfield
                    clearable
                    v-model="searchForm.employerName"
                    :label="
                      $t(
                        'components.employers.search_employers_form.employer_name'
                      )
                    "
                  />
                </v-col>
                <v-col cols="6">
                  <no-autocomplete-textfield
                    clearable
                    v-model="searchForm.employerNumber"
                    :label="
                      $t(
                        'components.employers.search_employers_form.employer_number'
                      )
                    "
                    :rules="[$rules.numeric, $rules.dynamic.upToLength(4), $rules.notOnlyFourZeros]"
                  />
                </v-col>
                <v-col cols="6">
                  <no-autocomplete-textfield
                    clearable
                    v-model="searchForm.storeName"
                    :label="
                      $t(
                        'components.employers.search_employers_form.store_name'
                      )
                    "
                  />
                </v-col>
                <v-col cols="6">
                  <no-autocomplete-textfield
                    clearable
                    v-model="searchForm.storeNumber"
                    :label="
                      $t(
                        'components.employers.search_employers_form.store_number'
                      )
                    "
                  />
                </v-col>
                <v-col cols="6">
                  <auto-select
                    v-model="searchForm.operator"
                    :label="$t('components.searchmemberformhours.operator')"
                    :items="operators"
                  />
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="auto">
                  <v-btn color="primary" @click="submitSearchForm">
                    {{ $t("pbascomponents.pbasdatatable.search") }}
                  </v-btn>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    text
                    @click="
                      searchForm.employerName = '';
                      searchForm.employerNumber = '';
                      searchForm.storeName = '';
                      searchForm.storeNumber = '';
                      submitSearchForm();
                    "
                  >
                    {{ $t("globals.reset") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </material-card>
        </v-col>
      </v-row>
    </v-layout>
    <v-layout v-if="showTable">
      <v-row justify="center">
        <v-col style="max-width:1200px">
          <v-card>
            <v-card-text>
              <div>
                <v-icon>list</v-icon>
                {{ $t("components.membersmanagementtable.results") }}
              </div>
              <pbas-data-table
                ref="table"
                :dataProvider="provider"
                :rowActions="rowActions"
                fileNamePrefix="employersSearch"
                :identifier="'search-employers-table' + selectedPlan.Id"
                :noSearch="true"
                :noActions="true"
                @error="error = $event"
              ></pbas-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
    <error-handler :error="error"></error-handler>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import { ODataProvider } from "pbas-vue-components";
import { translate2 } from "@/trans2";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import { planSetter } from "@/mixins/planSetter";
import getSearchEmployersHeaders from "@/headers/SearchEmployers";
import AutoSelect from "@/components/AutoSelect.vue";

export default {
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    AutoSelect
  },
  props: [],
  mixins: [planSetter],
  data() {
    return {
      showTable: false,
      panel: [0, 1],
      searchForm: {
        employerName: null,
        employerNumber: null,
        branchName: null,
        branchNumber: null,
        operator: null,
      },
      error: null,
      provider: undefined,
      rowActions: [
        {
          name: "viewItem",
          icon: "visibility",
          title: "components.membersmanagementtable.details",
          handler: (item) => {
            this.$router.push({
              name: "employerDetails",
              params: { planId: this.selectedPlan.Id, employerId: item.Id },
            });
          },
          visible: (item) => {
            return item;
          },
        },
      ],
      headers: [],
      selectedItem: null,
      operators: ["And", "Or"],
    };
  },
  computed: {
    ...mapGetters("common", ["language", "settings"]),
    ...mapGetters("auth", ["isLoggedIn", "user"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["planOptions"]),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
    planOptions: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined && this.planOptions) {
      this.loadPlanData();
    }
  },
  methods: {
    getDataAsync() {
      return this.$refs.table.getDataAsync();
    },

    async loadPlanData(filter = null) {
      // console.log("|load data");
      this.headers = getSearchEmployersHeaders(this.planOptions.HasStores);
      // console.log(this.headers);
      let url = "plans/" + this.selectedPlan.Id + "/employers";
      this.searchForm.operator = this.operators[0];
      if (!filter) {
        this.provider = new ODataProvider(this.$axiosHttp, url, this.headers);
      } else {
        const pr = new ODataProvider(this.$axiosHttp, url, this.headers);
        pr.filter = filter;
        this.provider = pr;
      }
    },
    async submitSearchForm() {
      const filters = [];
      this.provider.filter = undefined;
      if (this.searchForm.employerName) {
        filters.push(
          `(Current/Translations/any(_t: contains(tolower(_t/Name), '${this.searchForm.employerName
            .toLowerCase()
            .replaceAll("'", "''")}')) or contains(tolower(Current/Name), '${this.searchForm.employerName
            .toLowerCase()
            .replaceAll("'", "''")}'))`
        );
      }
      if (this.searchForm.employerNumber) {
        filters.push(
          `(contains(tolower(Current/Number), '${this.searchForm.employerNumber
            .toLowerCase()
            .replaceAll("'", "''")}'))`
        );
      }
      if (this.searchForm.storeName) {
        filters.push(
          `(Stores/any(_s: _s/Current/Translations/any(_t: contains(tolower(_t/Name), '${this.searchForm.storeName
            .toLowerCase()
            .replaceAll("'", "''")}')) or contains(toLower(_s/Current/Name), '${this.searchForm.storeName
            .toLowerCase()
            .replaceAll("'", "''")}')))`
        );
      }
      if (this.searchForm.storeNumber) {
        filters.push(
          `(Stores/any(_s: contains(tolower(_s/Current/Number), '${this.searchForm.storeNumber
            .toLowerCase()
            .replaceAll("'", "''")}')))`
        );
      }

      if (filters.length > 0) {
        const f = filters.join(` ${this.searchForm.operator.toLowerCase()} `);
        console.log(filters, f);
        this.provider.filter = f;
        this.showTable = true;
        this.$nextTick(() => {
          this.$refs.table.getDataAsync();
        });
      } else {
        this.showTable = false;
      }

      //await this.loadPlanData(filters.join(" and "));
    },
  },
};
</script>
